<template lang="html">

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/juridical')" style="cursor: pointer">Jurídico</li>
        <li class="breadcrumb-item active" aria-current="page">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Grupos de Contratos</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <md-card>
            <md-card-header>
              <div class="md-title">Grupos de Contratos
                <md-button class="md-icon-button md-raised md-primary" style="background-color: green; float: right" v-on:click="editGroup='New'">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>ID</md-table-head>
                  <md-table-head>Nombre</md-table-head>
                  <md-table-head>Tipo</md-table-head>
                  <md-table-head>Req. Ver. Identidad</md-table-head>
                  <md-table-head>Días para firmar</md-table-head>
                  <md-table-head>Leyenda de Aceptación</md-table-head>
                  <md-table-head style="text-align: center">Editar | Borrar</md-table-head>
                </md-table-row>
                <md-table-row v-if="editGroup==='New'">
                  <md-table-cell>{{editGroup}}</md-table-cell>

                  <md-table-cell>
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell>
                    <md-field>
                      <label>Tipo</label>
                      <md-select v-model="type">
                        <md-option value="1">Grupo 1 y 2, requiere sent para publicar y signed para pago de anticipo</md-option>
                        <md-option value="2">Grupo 3 y 4, requiere signed para pago de anticipo</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="identity_validation_request"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell>
                    <md-field>
                      <label>Días para firmar</label>
                      <md-input v-model="signing_due_days" type="number" min="0"/>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell>
                    <md-field>
                      <label>Leyenda de Aceptación</label>
                      <md-textarea v-model="acceptance_caption" md-autogrow/>
                    </md-field>
                  </md-table-cell>

                  <md-table-cell style="width: 16%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>

                </md-table-row>
                <md-table-row v-for="contract_group in contract_groups" :key="contract_group.id">
                  <md-table-cell>{{contract_group.id}}</md-table-cell>

                  <md-table-cell v-if="editGroup===contract_group.id">
                    <md-field>
                      <label>Nombre</label>
                      <md-textarea v-model="name" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract_group.name}}</md-table-cell>

                  <md-table-cell v-if="editGroup===contract_group.id">
                    <md-field>
                      <label>Tipo</label>
                      <md-select v-model="type">
                        <md-option value="1">Grupo 1 y 2, requiere sent para publicar y signed para pago de anticipo</md-option>
                        <md-option value="2">Grupo 3 y 4, requiere signed para pago de anticipo</md-option>
                      </md-select>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>
                    <div v-if="contract_group.type == 1">Grupo 1 y 2, requiere sent para publicar y signed para pago de anticipo</div>
                    <div v-else-if="contract_group.type == 2">Grupo 3 y 4, requiere signed para pago de anticipo</div>
                    <div v-else>{{contract_group.type}}</div>
                  </md-table-cell>

                  <md-table-cell style="text-align: center" v-if="editGroup===contract_group.id">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="identity_validation_request"/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>
                  <md-table-cell v-else style="text-align: center">
                    <label class="container">
                      <input type="checkbox" class="form-control" v-model="contract_group.identity_validation_request" disabled/>
                      <span class="checkmark" />
                    </label>
                  </md-table-cell>

                  <md-table-cell v-if="editGroup===contract_group.id">
                    <md-field>
                      <label>Días para firmar</label>
                      <md-input v-model="signing_due_days" type="number" min="0"/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract_group.signing_due_days}}</md-table-cell>

                  <md-table-cell v-if="editGroup===contract_group.id">
                    <md-field>
                      <label>Leyenda de Aceptación</label>
                      <md-textarea v-model="acceptance_caption" md-autogrow/>
                    </md-field>
                  </md-table-cell>
                  <md-table-cell v-else>{{contract_group.acceptance_caption}}</md-table-cell>

                  <md-table-cell style="width: 20%;text-align: center" v-if="editGroup===contract_group.id">
                    <md-button class="md-icon-button md-mini md-raised" v-on:click="guardarGroup()">
                      <md-icon>save</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="limpiar()">
                      <md-icon>clear</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell v-else style="width: 20%;text-align: center">
                    <md-button class="md-icon-button md-mini md-raised md-primary" v-on:click="editarGroup(contract_group)">
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-icon-button md-mini md-raised md-accent" v-on:click="borrarGroup(contract_group.id)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">

  export default  {
    name: 'contract-groups',
    props: [],
    mounted () {
      this.getContractGroups();
    },
    data () {
      return {
        contract_groups: [],

        editGroup: null,
        name: null,
        type: null,
        identity_validation_request: null,
        signing_due_days: null,
        acceptance_caption: null,
      }
    },
    methods: {
      limpiar(){
        this.editGroup = null;
        this.name = null;
        this.type = null;
        this.identity_validation_request = null;
        this.signing_due_days = null;
        this.acceptance_caption = null;
      },
      getContractGroups(){
        axios.get( '/api/catalogs/contract_groups').then(response => {
          this.contract_groups = response.data.data;
        });
      },
      guardarGroup(){
        Vue.toasted.show('Guardando Grupo de Contratos...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/contract_groups/save', {
          'contract_group_id': this.editGroup === 'New' ? -1 : this.editGroup,
          'name': this.name,
          'type': this.type,
          'identity_validation_request': this.identity_validation_request,
          'signing_due_days': this.signing_due_days,
          'acceptance_caption': this.acceptance_caption,
        }).then(response => {
          this.limpiar();
          this.getContractGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Contratos guardado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      editarGroup(group){
        this.editGroup = group.id;
        this.name = group.name;
        this.type = group.type;
        this.identity_validation_request = group.identity_validation_request;
        this.signing_due_days = group.signing_due_days;
        this.acceptance_caption = group.acceptance_caption;
      },
      borrarGroup(gid){
        Vue.toasted.show('Borrando Grupo de Contratos...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/catalogs/contract_groups/delete', {
          'contract_group_id': gid,
        }).then(response => {
          this.getContractGroups();
          Vue.toasted.clear();
          Vue.toasted.show('¡¡ Grupo de Contratos borrado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
    },
    computed: {

    }
}


</script>

<style scoped>
  /* Customize the label (the container) */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 35px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    margin-left: 30%;
    border-radius: 30px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: rgb(243, 205, 33);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
